


















































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import notificationService from '@/services/notificationService';
import { InvoicesClient, InvoiceStatsDto } from '@/data/web-api-client';

@Component({
  components: {},
})
export default class InvoicesStats extends Vue {
  @Prop({ required: false, default: '' })
  private projectId!: string;

  private loading: boolean = true;
  private stats: InvoiceStatsDto | null = null;

  private created() {
    this.loadData();
  }

  private async loadData() {
    try {
      this.loading = true;
      this.stats = await new InvoicesClient(undefined, this.$axios).getStats(this.projectId);
    } catch (err) {
      notificationService.showAxiosError(err);
    } finally {
      this.loading = false;
    }
  }
}
